module.exports = [
    {
    	path: '*',
    	component: components.layouts.home
    }
];
